import { select, put, call } from "redux-saga/effects";
import { validate } from "./utility";
import API from "../../API";
import {inputError, loginError, loginSuccess} from "./login-action-creators";
import {redirect} from "../../sagas/redirect-saga";

const WRONG_CREDENTIALS = "Unable to log in with provided credentials.";

export function* loginRequest({ history }) {
  const username = yield select(state => state.login.username);
  const password = yield select(state => state.login.password);
  const usernameValid = yield call(validate, { input: username, action: inputError });
  const passwordValid = yield call(validate, { input: password, action: inputError });
  if (usernameValid && passwordValid) {
    try {
      const { data: { token }} = yield call(API.login, {
        username: username.value,
        password: password.value
      });
      if (token) {
        localStorage.token = token;
        yield put(loginSuccess(token));
        yield call(redirect, { history, path: "/"});
      } else {
        yield put(loginError("No token"));
      }
    } catch (error) {
      let errorMessage;
      if (error.response.data.non_field_errors && error.response.data.non_field_errors[0] === WRONG_CREDENTIALS) {
        errorMessage = "Wrong username or password"
      } else {
        errorMessage = "Something went wrong...";
      }
      yield put(loginError(errorMessage));
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/login-saga.js